




















































































































































import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { VueEditor } from "vue2-editor";

import LanguagesButtons from "../../buttons/languages-buttons.vue";
import UploadingImageToServer from "../../app/images/uploading-image-to-server.vue";
import SubmitResetButtonGroop from "../../buttons/submit-reset-button-groop.vue";

import { required, maxLength } from "vuelidate/lib/validators";
import { IRouteCity } from "@/@types/routeInfo/route-info";
import { ILocale } from "@/@types/locale";

@Component({
  components: {
    LanguagesButtons,
    UploadingImageToServer,
    SubmitResetButtonGroop,
    VueEditor,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    description: { maxLength: maxLength(5000) },
    address: { maxLength: maxLength(100) },
    excursion: { maxLength: maxLength(5000) },
  },
})
export default class ChangeCityForm extends Vue {
  @Prop({ type: Object, default: null }) city!: IRouteCity;
  locale = this.$store.getters.getLanguages[0];

  name = "";
  description = "";
  address = "";
  excursion = "";
  poster = "";
  textEditor = "html";
  names: ILocale = {};
  adresess: ILocale = {};
  descriptions: ILocale = {};
  excursions: ILocale = {};

  get cityObg(): IRouteCity {
    return {
      _id: this.city && this.city._id ? this.city._id : undefined,
      id: this.city && this.city.id ? this.city.id : null,
      name: this.names,
      description: this.descriptions,
      address: this.adresess,
      code: this.city && this.city.code ? this.city.code : "",
      type: this.city && this.city.type != undefined ? this.city.type : null, // 0 - начальный и конечный город
      excursion: this.excursions,
      image: {
        name: this.poster,
        url: this.city && this.city.image ? this.city.image.url : "",
      },
    };
  }

  getPsoterName(poster_name: string): void {
    this.poster = poster_name;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }

    this.$emit("submitSend", this.cityObg);
  }

  onReset(): void {
    this.name = "";
    this.description = "";
    this.address = "";
    this.excursion = "";
    this.locale = this.$store.getters.getLanguages[0];
    this.names = {};
    this.descriptions = {};
    this.adresess = {};
    this.adresess = {};
    this.excursions = {};
  }

  @Watch("poster")
  updateDemo(): void {
    this.$emit("updateDemo", this.cityObg);
  }

  @Watch("name")
  updateName(): void {
    this.names[this.locale] = this.name;
    this.updateDemo();
  }

  @Watch("description")
  updateDescription(): void {
    this.descriptions[this.locale] = this.description;
    this.updateDemo();
  }

  @Watch("address")
  updateAddress(): void {
    this.adresess[this.locale] = this.address;
    this.updateDemo();
  }

  @Watch("excursion")
  updateExcursion(): void {
    this.excursions[this.locale] = this.excursion;
    this.updateDemo();
  }

  @Watch("locale")
  getParams(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";

    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";

    if (this.adresess)
      this.address = this.adresess[this.locale]
        ? this.adresess[this.locale]
        : "";
    else this.address = "";

    if (this.excursions)
      this.excursion = this.excursions[this.locale]
        ? this.excursions[this.locale]
        : "";
    else this.excursion = "";

    this.updateDemo();
  }

  mounted(): void {
    if (this.city) {
      this.poster = this.city.image.name ? this.city.image.name : "";
      this.names = this.city.name ? this.city.name : {};
      this.adresess = this.city.address ? this.city.address : {};
      this.excursions = this.city.excursion ? this.city.excursion : {};
      this.descriptions = this.city.description ? this.city.description : {};
      this.getParams();
    }
  }
}
